import React, { useState } from "react";
import {
  FaAngleLeft,
  FaAngleRight,
  FaFileUpload,
  FaLink,
} from "react-icons/fa";

const NewOrganization = ({
  register,
  handleSubmit,
  errors,
  onSubmit,
  watch,
  setTabs,
}) => {
  const [licenseFile, setLicenseFile] = useState(null);
  const [addressProofFile, setAddressProofFile] = useState(null);
  const [govIdFile, setGovIdFile] = useState(null);
  const [passportPhotoFile, setPassportPhotoFile] = useState(null);
  const countries = ["India", "USA", "France", "Germany", "China"];
  const [selected, setSelected] = useState("LinkedIn");

  const options = [
    { name: "LinkedIn", placeholder: "Enter LinkedIn link" },
    { name: "GitHub", placeholder: "Enter GitHub link" },
    { name: "Portfolio", placeholder: "Enter Portfolio link" },
  ];

  const current = options.find((opt) => opt.name === selected);

  return (
    <form className="space-y-5 px-1 py-10" onSubmit={handleSubmit(onSubmit)}>
      {/* Business / Organization Name */}
      <div>
        <label className="block font-medium mb-1">
          Business / Organization Name
        </label>
        <input
          type="text"
          {...register("businessName", { required: true })}
          placeholder="Enter Business Name"
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
        {errors.businessName && (
          <p className="text-sm text-red-500">Business name is required</p>
        )}
      </div>

      {/* Email & Mobile */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block font-medium mb-1">Email</label>
          <input
            type="email"
            {...register("email", { required: true })}
            placeholder="Enter Email"
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          />
          {errors.email && (
            <p className="text-sm text-red-500">Email is required</p>
          )}
        </div>

        <div>
          <label className="block font-medium mb-1">Mobile Number</label>
          <div className="flex gap-2">
            {/* Country Select */}
            <select
              {...register("country", { required: true })}
              className="w-23  border rounded-md p-1 py-3 bg-[#f0f0f0] outline-none focus:ring-2 focus:ring-green-700"
            >
              {countries.map((res, i) => (
                <option key={i} value={res}>
                  {res}
                </option>
              ))}
            </select>

            {/* Phone Number Input */}
            <input
              type="tel"
              {...register("mobile", { required: true })}
              placeholder="123-456-7890"
              className="flex-1 min-w-0 border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
            />
          </div>

          {/* Error Messages */}
          {errors.country && (
            <p className="text-sm text-red-500">Country is required</p>
          )}
          {errors.mobile && (
            <p className="text-sm text-red-500">Mobile number is required</p>
          )}
        </div>
      </div>

      {/* Registered Address */}
      <div>
        <label className="block font-medium mb-1">Registered Address</label>
        <textarea
          {...register("address", { required: true })}
          placeholder="Enter Registered Address"
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
        {errors.address && (
          <p className="text-sm text-red-500">Address is required</p>
        )}
      </div>

      {/* Website */}
      <div>
        <label className="block font-medium mb-1">Website</label>
        <input
          type="url"
          {...register("website")}
          placeholder="Enter Website"
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
      </div>

      {/* Organization Description */}
      <div>
        <label className="block font-medium mb-1">
          Organization Description
        </label>
        <input
          {...register("description")}
          placeholder="Enter Organization Description"
          className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
        />
      </div>

      {/* Social Links */}

      <div className="w-full max-w-sm min-w-[200px] mt-4">
        <label className="block font-medium mb-1">Social Links</label>
        <div className="relative mt-2">
          {/* Dropdown on left side */}
          <div className="absolute top-2  left-0 flex items-center pl-3">
            <button
              type="button"
              className="h-full text-sm flex justify-center items-center bg-transparent text-slate-700 focus:outline-none"
              onClick={() =>
                document
                  .getElementById("dropdownMenu")
                  .classList.toggle("hidden")
              }
            >
              {selected}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="h-4 w-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                />
              </svg>
            </button>
            <div className="h-6 border-l border-slate-200 ml-2"></div>

            {/* Dropdown menu */}
            <div
              id="dropdownMenu"
              className="min-w-[150px] absolute left-0 mt-10 hidden bg-white border border-slate-200 rounded-md shadow-lg z-10"
            >
              <ul>
                {options.map((opt) => (
                  <li
                    key={opt.name}
                    className="px-4 py-2 text-slate-600 hover:bg-slate-50 text-sm cursor-pointer"
                    onClick={() => {
                      setSelected(opt.name);
                      document
                        .getElementById("dropdownMenu")
                        .classList.add("hidden");
                    }}
                  >
                    {opt.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Input with Icon on Right */}
          <input
            type="url"
            {...register("social")}
            placeholder={current?.placeholder}
            className="w-full bg-transparent  p-3 placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md pl-32 pr-10 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
          />
        </div>
      </div>

      {/* Organization Type & Tax ID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block font-medium mb-1">Organization Type</label>
          <select
            {...register("orgType", { required: true })}
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          >
            <option value="">Select Organization Type</option>
            <option value="ngo">NGO</option>
            <option value="trust">Trust</option>
            <option value="company">Company</option>
          </select>
          {errors.orgType && (
            <p className="text-sm text-red-500">
              Organization type is required
            </p>
          )}
        </div>
        <div>
          <label className="block font-medium mb-1">
            Tax ID / NGO Certification
          </label>
          <input
            type="text"
            {...register("taxId")}
            placeholder="Enter Tax ID"
            className="w-full border rounded-md p-3 outline-none focus:ring-2 focus:ring-green-700"
          />
        </div>
      </div>

      {/* File Uploads */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[
          {
            id: "license-upload",
            label: "License / Registration Certificate",
            file: licenseFile,
            setFile: setLicenseFile,
            registerName: "license",
          },
          {
            id: "address-upload",
            label: "Proof of Address",
            file: addressProofFile,
            setFile: setAddressProofFile,
            registerName: "addressProof",
          },
          {
            id: "gov-id-upload",
            label: "Government Issued ID",
            file: govIdFile,
            setFile: setGovIdFile,
            registerName: "govId",
          },
          {
            id: "passport-upload",
            label: "Passport Size Photo",
            file: passportPhotoFile,
            setFile: setPassportPhotoFile,
            registerName: "passportPhoto",
          },
        ].map(({ id, label, file, setFile, registerName }) => (
          <div key={id}>
            <label className="block font-medium mb-1">{label}</label>
            <div className="flex items-center w-full border rounded-lg px-3 py-2 focus-within:ring-2 focus-within:ring-green-600">
              <input
                type="file"
                accept="application/pdf,image/*"
                id={id}
                className="hidden"
                {...register(registerName, {
                  onChange: (e) => {
                    const fileSelected = e.target.files[0];
                    setFile(fileSelected); // keep local preview state
                  },
                })}
              />
              <label
                htmlFor={id}
                className="flex-grow cursor-pointer text-sm text-gray-500 truncate"
              >
                {file ? file.name : `Upload ${label}`}
              </label>
              <label htmlFor={id} className="cursor-pointer">
                <FaFileUpload className="text-[25px]" />
              </label>
            </div>
          </div>
        ))}
      </div>

      {/* Buttons */}
      <div className="flex justify-between mt-6">
        <button
          onClick={() => setTabs(1)}
          type="button"
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          <FaAngleLeft /> Back
        </button>

        {/* ✅ Next should SUBMIT instead of just switching tab */}
        <button
          onClick={handleSubmit(() => setTabs(3))}
          type="submit"
          className="px-3 flex items-center gap-10 py-2 rounded-full bg-green-800 text-white hover:bg-green-900"
        >
          Next <FaAngleRight />
        </button>
      </div>
    </form>
  );
};

export default NewOrganization;
